// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ConfirmationBanner-cls1___5c13063ae607ea64216{/*!*/}.ConfirmationBanner-cls2___db7c13c016a6072d779{align-items:center;background:#f0ad4e;color:#fff;font-size:14px;font-weight:700;display:flex;min-height:40px;padding:10px;justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ConfirmationBanner-cls1___5c13063ae607ea64216",
	"cls2": "ConfirmationBanner-cls2___db7c13c016a6072d779 ConfirmationBanner-cls1___5c13063ae607ea64216"
};
export default ___CSS_LOADER_EXPORT___;
